'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonFunctions = require('../../helpers/commonFunctions');

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function populateCoverageData(context, data) {
  context.updateProp('application.additional_data.policy_type', data.additional_data.policy_type);
  context.updateProp('application.additional_data.destination', data.additional_data.destination);
  context.updateProp('application.additional_data.deductible', data.additional_data.deductible);
  context.updateProp('application.additional_data.state', data.additional_data.state);
  context.updateProp('application.additional_data.travelling_through_the_us', data.additional_data.travelling_through_the_us);
  context.updateProp('application.additional_data.number_of_days_per_trip', data.additional_data.number_of_days_per_trip);
  context.updateProp('application.additional_data.coverage_length', data.additional_data.coverage_length);
  context.updateProp('application.additional_data.home_province', data.additional_data.home_province);
  (0, _commonFunctions.populateEligibility)(context, data);
}

function getRelativePath(fieldPath, type) {
  var parts = fieldPath.split('.');

  var index = parts.findIndex(function (part) {
    return part.startsWith(type);
  });

  if (index === -1) return '';
  return parts.slice(index + 1).join('.');
}

function fillQuestion(context, propPrefix, data, fullFieldPath, type) {
  var fieldPath = getRelativePath(fullFieldPath, type);

  if (!fieldPath) return;

  var fullReduxPath = propPrefix + '.additional_data.' + type + '.' + fieldPath;

  var _fieldPath$split = fieldPath.split('.'),
      _fieldPath$split2 = _toArray(_fieldPath$split),
      mqKey = _fieldPath$split2[0],
      subPathParts = _fieldPath$split2.slice(1);

  if (!mqKey || !data[mqKey]) return;

  var value = subPathParts.length === 0 ? data[mqKey] : subPathParts.reduce(function (obj, key) {
    return obj && obj[key] !== undefined ? obj[key] : undefined;
  }, data[mqKey]);

  context.updateProp(fullReduxPath, value);
}

function populateQuestionnaireData(context, propPrefix, data) {
  (0, _commonFunctions.getApplicantMedicalquestions)().forEach(function (fieldPath) {
    fillQuestion(context, propPrefix, data.mq, fieldPath, 'mq');
  });

  (0, _commonFunctions.getApplicantSportFields)().forEach(function (fieldPath) {
    context.updateProp(propPrefix + '.additional_data.sports', data.sports);
    fillQuestion(context, propPrefix, data.sports_coverage, fieldPath, 'sports_coverage');
  });
}

function populateApplicantsAdditionalData(context, data) {
  data.additional_data.applicants.forEach(function (applicant, i) {
    populateQuestionnaireData(context, 'applicant[' + i + ']', applicant.additional_data);
  });
}

function populateProductSpecificData(context, data) {
  populateCoverageData(context, data);
  populateApplicantsAdditionalData(context, data);
}

exports.default = function (context) {
  (0, _commonFunctions.populateQuoteData)(context, populateProductSpecificData);
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/tugo/quote.js
// module id = 1764
// module chunks = 0